import { IFormServiceState } from "./model"
import { getDefaultBoxState } from "./tools/tab-boxes"

export const state: IFormServiceState = {
  saveFormTimeout: undefined,
  pendingFormToSave: null,
  sspTimeout: undefined,
  sspIsSynchronizing: false,
  sspToApplySelection: null,
  environmentsTimeout: undefined,
  environmentsIsSynchronizing: false,
  environmentsToApplySelection: null,
  environmentsForecastTimeout: undefined,
  environmentsForecastIsLoading: false,
  environmentsForecastRefreshAgain: false,
  operatorRunId: 0,
  operatorTimeout: undefined,
  operatorIsSynchronizing: false,
  operatorToApplySelection: null,
  audienceTimeout: undefined,
  audienceIsSynchronizing: false,
  sspDealsTimeout: undefined,
  sspDealsIsSynchronizing: false,
  sspDealsToApplySelection: null,
  audienceToApplySelection: null,
  isInventoryRefreshing: false,
  campaignIdToRefreshForInventory: null,
  tabBoxIsOpenedById: getDefaultBoxState(),
  photoResizeTimeOut: undefined,
  mediaCreativeForecastIsLoading: false,
  mediaCreativeForecastRefreshAgain: false,
  mediaCreativeForecastTimeout: undefined,
  mediaCreativeForecastIsSynchronizing: false,
  mediaCreativeForecastToApplySelection: null
}

if (IS_NOT_PROD) {
  const win = window as any
  win.formState = state
}
